/* ============================================================
   Marjo et son petit robot pref 🤖

   TRADUCTION ZEPTO, PANIER
   ------------------------------------------------------------
   Rôle :
   - traduire les propriétés Zepto affichées dans le panier
   - traduire les labels visibles
   - traduire les valeurs visibles
   - laisser les liens d’aperçu gérés par Liquid
   - retraduire après les mises à jour dynamiques du panier

   Résout :
   - corrige les labels Zepto qui restaient en français
   - rend le script plus robuste si le thème ajoute un espace
     après les deux-points dans les <dt>
   - empêche le retour au français après modification de quantité
   - empêche le retour au français après suppression d’un produit
   - empêche le retour au français après application d’un rabais
   - sans toucher à la logique Zepto
   - sans toucher au checkout

   Pages :
   - panier

   App impliquée :
   - Zepto Product Personalizer
   ============================================================ */

(function () {
  function isEnglishPage() {
    const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return htmlLang.startsWith("en");
  }

  function normalizeText(text) {
    return String(text || "")
      .replace(/\s+/g, " ")
      .replace(/\(\s+/g, "(")
      .replace(/\s+\)/g, ")")
      .trim();
  }

  function cleanCartLabel(text) {
    return normalizeText(text)
      .replace(/\s*:\s*$/, "")
      .trim();
  }

  function getCartTranslations() {
    return {
      labels: {
        "Numéro de porte": "Door number",
        "Couleur": "Color",
        "Taille": "Size",
        "Sens": "Orientation",
        "Type d'installation": "Installation type",
        "Nombre de chiffres": "Number of digits",
        "Trousse d'installation incluse": "Installation kit included",
        "Aperçu": "Preview",
        "Couleur des numéros": "Number color",
        "Couleur de boîte aux lettres": "Mailbox color",
        "Format de la plaque": "Address plaque size",
        "Format de la plaque:": "Address plaque size",
        "Option de verrouillage": "Mailbox locking option",

        /* Linea */
        "Longueur de la barre": "Bar length",
        "Transformateur": "Transformer",
        "Longueur de fils électrique": "Wire length",
        "Caractère 2'' (positionnement haut)": "Character 2'' (top position)",
        "Caractère 2'' (positionnement bas)": "Character 2'' (bottom position)",
        "Chiffre 7'' (positionnement haut)": "Number 7'' (top position)",
        "Chiffre 7'' (positionnement bas)": "Number 7'' (bottom position)",
        "Chiffre 9'' (positionnement haut)": "Number 9'' (top position)",
        "Chiffre 9'' (positionnement bas)": "Number 9'' (bottom position)"
      },
      values: {
        "Noir": "Black",
        "Blanc": "White",
        "Aluminium brossé": "Brushed Aluminum",
        "Horizontal": "Horizontal",
        "Vertical": "Vertical",
        "Standard (trousse gratuite)": "Standard (free accessories kit)",
        "Standard ( trousse gratuite)": "Standard (free accessories kit)",
        "Standard (trousse gratuite )": "Standard (free accessories kit)",
        "Aimanté (pour les revêtements d'acier)": "Magnetic (for steel siding)",
        "Collé": "3M adhesive (no drilling required)",
        "Oui": "Yes",
        "Non": "No",
        "Autres formats": "Other sizes",
        "Formats réguliers": "Regular sizes",
        "Argile mat": "Matte Clay",
        "Canyon lustré": "Glossy Canyon",
        "Olive lustré": "Glossy Olive",
        "Vert ancien lustré": "Glossy Yesterday Green",
        "Barista lustré": "Glossy Barista",
        "Sans serrure": "Without lock",
        "Avec serrure": "With lock",

        /* Linea */
        "Barre-8-5": '8.5" bar',
        "Barre-13": '13" bar',
        "Barre-19-5": '19.5" bar',
        "Barre-25": '25" bar',
        "Barre-33-5": '33.5" bar',
        "Branchable 24v / 110v (30 watts)": "Plug-in 24V / 110V (30 watts)"
      }
    };
  }

  function translateCartProperties() {
    if (!isEnglishPage()) return;

    const config = getCartTranslations();
    const items = document.querySelectorAll(".product-option");

    items.forEach(function (el) {
      const dt = el.querySelector("dt");
      const dd = el.querySelector("dd");

      if (!dt || !dd) return;

      const rawLabel = cleanCartLabel(dt.textContent);
      const rawValue = normalizeText(dd.textContent);

      const translatedLabel = config.labels[rawLabel];
      if (translatedLabel && translatedLabel !== rawLabel) {
        dt.textContent = translatedLabel + ":";
      }

            const previewLink = dd.querySelector("a");

      if (previewLink) {
        const linkText = normalizeText(previewLink.textContent);

        if (linkText === "Cliquez pour voir l'image") {
          previewLink.textContent = "Click here to view the image";
        }

        return;
      }

      const translatedValue = config.values[rawValue];
      if (translatedValue && translatedValue !== rawValue) {
        dd.textContent = translatedValue;
      }
    });
  }

  let translateTimeout = null;

  function scheduleCartTranslation(delay) {
    if (!isEnglishPage()) return;

    clearTimeout(translateTimeout);
    translateTimeout = setTimeout(function () {
      translateCartProperties();
    }, delay || 120);
  }

  function initCartTranslation() {
    if (!isEnglishPage()) return;

    translateCartProperties();

    new MutationObserver(function () {
      scheduleCartTranslation(120);
    }).observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(translateCartProperties, 300);
    setTimeout(translateCartProperties, 800);
    setTimeout(translateCartProperties, 1500);
    setTimeout(translateCartProperties, 2500);

    document.addEventListener("change", function () {
      scheduleCartTranslation(120);
    });

    document.addEventListener("click", function () {
      scheduleCartTranslation(180);
    });

    document.addEventListener("submit", function () {
      scheduleCartTranslation(250);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartTranslation);
  } else {
    initCartTranslation();
  }

  window.addEventListener("load", function () {
    scheduleCartTranslation(120);
  });
})();